import { render, staticRenderFns } from "./360Feedback.vue?vue&type=template&id=1a31a260"
import script from "./360Feedback.vue?vue&type=script&lang=js"
export * from "./360Feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports